import { render } from "./RewardListIcon.vue?vue&type=template&id=156b5132"
import script from "./RewardListIcon.vue?vue&type=script&lang=js"
export * from "./RewardListIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__